module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-solar.svg?2286ab89129a5a3bf242c160a9d17b99";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-solar.svg
// module id = 1049
// module chunks = 1